// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3oQfa","insightsList":"newBusinessInsightsMenu_insightsList__Gculy","active":"newBusinessInsightsMenu_active__t1sx5"};